import Axios from "axios";
import {
  getLcImportLcCostingList,
  getLcImportLcCostingById as getLcImportLcCostingByIdApi,
  saveUpdateLcImportLcCosting,
} from "@/store/api";
import {
  SET_LC_IMPORT_LC_COSTING_LIST,
  UNSET_LC_IMPORT_LC_COSTING_LIST,
  SET_EDITING_LC_IMPORT_LC_COSTING,
  UNSET_EDITING_LC_IMPORT_LC_COSTING,
} from "@/store/mutation-types";

const state = {
  lcImportLcCostingList: [],
  editingLcImportLcCosting: null,
};

const getters = {
  getLcImportLcCostingList(state) {
    return state.lcImportLcCostingList;
  },
  getEditingLcImportLcCosting(state) {
    return state.editingLcImportLcCosting;
  },
};

const mutations = {
  [SET_LC_IMPORT_LC_COSTING_LIST](state, data) {
    state.lcImportLcCostingList = data;
  },
  [UNSET_LC_IMPORT_LC_COSTING_LIST](state) {
    state.lcImportLcCostingList = [];
  },
  [SET_EDITING_LC_IMPORT_LC_COSTING](state, data) {
    state.editingLcImportLcCosting = data;
  },
  [UNSET_EDITING_LC_IMPORT_LC_COSTING](state) {
    state.editingLcImportLcCosting = null;
  },
};

const actions = {
  saveUpdateLcImportLcCosting({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateLcImportLcCosting, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getLcImportLcCostingList({ commit }) {
    return new Promise((resolve, reject) => {
      console.log('🔍 Store: Fetching costing list from:', getLcImportLcCostingList);
      Axios.get(getLcImportLcCostingList)
        .then((response) => {
          console.log('🔍 Store: API Response:', response);
          console.log('🔍 Store: Response data:', response.data);
          if (response.data.success) {
            console.log('🔍 Store: Committing data to store:', response.data.data);
            commit(SET_LC_IMPORT_LC_COSTING_LIST, response.data.data);
            console.log('🔍 Store: Data committed successfully');
          } else {
            console.warn('⚠ Store: API returned success=false');
          }
          resolve(response);
        })
        .catch((error) => {
          console.error('✗ Store: Error fetching costing list:', error);
          console.error('✗ Store: Error response:', error.response?.data || error.message);
          reject(error);
        });
    });
  },
  getLcImportLcCostingById({ commit }, id) {
    const url = `${getLcImportLcCostingByIdApi}${id}`;
    return new Promise((resolve, reject) => {
      Axios.get(url)
        .then((response) => {
          if (response.data.success) {
            commit(SET_EDITING_LC_IMPORT_LC_COSTING, response.data.data);
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

